import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ApiResponse } from '@core/models/api-response.model';
import { map, tap } from 'rxjs/operators';
import { CreditCard } from '@core/models/credit-card.model';
import { AesService } from '@core/services/aes.service';

@Injectable({
  providedIn: 'root'
})

export class CreditCardHttpService {
  private baseUrl = '/creditcards';

  messages$ = new Subject<any[]>();
  isSuccess: boolean;

  constructor(
    private http: HttpClient,
    private aesService: AesService,
  ) {}

  getAll(): Observable<any> {
    return this.http.get<ApiResponse>(`${this.baseUrl}`).pipe(
      map(res => res.data.rows)
    );
  }

  getWithQuery(pageParam: string): Observable<any> {
    return this.http.get<ApiResponse>(`${this.baseUrl}${pageParam}`).pipe(
      map(res => {
        const data = res.data.rows;

        return data.map(item => {
          if( item && item.card_number ) {
            item.decrypted_card_number = this.aesService.decryptWithReqSignKey(item.card_number);
          }
          return item;
        });
    
      })
    );
  }

  getById(id: number): Observable<any> {
    return this.http.get<ApiResponse>(`${this.baseUrl}/${id}`).pipe(
      map(res => {
        const data = res.data.rows;

        if( data && data.card_number ) {
          data.decrypted_card_number = this.aesService.decryptWithReqSignKey(data.card_number);
        }

        return data;
      })
    );
  }

  create(data: CreditCard) {
    const cardNumber = data.card_number.replace(/\D/g, '');
    data.card_number = this.aesService.encryptWithReqSignKey(cardNumber);
    return this.http.post<ApiResponse>(`${this.baseUrl}`, data).pipe(
      map(res => {
        this.messages$.next(res.message);
        this.isSuccess = res.success;
      })
    );
  }

  update(id: number, data: CreditCard): Observable<any> {
    const cardNumber = data.card_number.replace(/\D/g, '');
    data.card_number = this.aesService.encryptWithReqSignKey(cardNumber);  
    return this.http.put<ApiResponse>(`${this.baseUrl}/${id}`, data).pipe(
      tap(res => {
        this.messages$.next(res.message);
        this.isSuccess = res.success;
      }),
      map(res => res.data.rows)
    );
  }

  delete(id: number): Observable<any> { 
    return this.http.delete<ApiResponse>(`${this.baseUrl}/${id}`).pipe(
      tap(res => {
        this.messages$.next(res.message);
        this.isSuccess = res.success;
      }),
      map(res => res.data.rows)
    );
  }
}